<template>
	<f7-page name="ccm-examset-apply" class="page-bg-render">
		<f7-navbar>
			<div class="title">
				<span v-if="mode=='ANSWER'">답안입력</span>
				<span v-else>채점결과</span>
			</div>
			<f7-nav-right>
				<f7-link icon-ios="f7:close" icon-aurora="f7:close" icon-md="material:close" class="back"></f7-link>
			</f7-nav-right>
		</f7-navbar>
		<f7-block-title>
			코드 : {{matchBookInfo.MATCHBOOK_CODE}}, 범위 : {{startPageNo}}p. {{startExamNo}}. ~ {{endPageNo}}p. {{endExamNo}}.<br/>
			제목 : {{matchBookInfo.MATCHBOOK_NAME}}
		</f7-block-title>
		<div class="list">
			<ul v-if="answers.length">
				<li v-for="(exam, i) in answers" :key="'i' + i">
					<obj-input v-if="exam.answerType == 'obj'" :seqIndex="i" :pageNo="exam.pageNo" :examNo="exam.examNo" :key="forceRenderId"></obj-input>
					<sbj-input v-else-if="exam.answerType == 'sbj'" :seqIndex="i" :pageNo="exam.pageNo" :examNo="exam.examNo" :key="forceRenderId"></sbj-input>
					<des-input v-else-if="exam.answerType == 'des'" :seqIndex="i" :pageNo="exam.pageNo" :examNo="exam.examNo" :key="forceRenderId"></des-input>
					<null-input v-else :seqIndex="i" :pageNo="exam.pageNo" :examNo="exam.examNo" :key="forceRenderId"></null-input>
				</li>
			</ul>
			<p v-else class="text-align-center padding-vertical">로딩중...</p>
		</div>

		<div class="block">
			<div class="row">
				<div class="left"></div>
				<div class="right">
					<button class="button button-fill" v-on:click="submitButtonClick" v-if="mode == 'ANSWER'">답안제출</button>
					<span class="txt-color-primary" v-else>답안 제출이 완료 되었습니다.</span>
				</div>
			</div>
		</div>
		
	</f7-page>
</template>

<script>
	import Vue from 'vue';
	import { f7 } from 'framework7-vue';
	import store from '../../../../js/store';

	import MODULE from '../../../../js/common/module';
	import AUTH from '../../../../js/common/auth.js';
	import PAGES from '../../../../js/pages';
	import API from '../../../../js/common/api.js';
	import CONST from '../../../../js/common/constant';

	import ObjInput from '../../../../components/answer/obj-input';
	import SbjInput from '../../../../components/answer/sbj-input';
	import DesInput from '../../../../components/answer/des-input';
	import NullInput from '../../../../components/answer/null-input';
	
	export default {
		components: {
			ObjInput,
			SbjInput,
			DesInput,
			NullInput
		},
		data() {
			return {
				forceRenderId: 1,
				mode: "ANSWER",
				studyKey: 0,
				matchBookCode: "",
				studyType: "",				
				studyResultKey: 0,
				startPageNo: 0,
				startExamNo: 0,
				endPageNo: 0,
				endExamNo: 0,
				matchBookInfo: {},
				answers: []
			}
		},
		mounted() {
			var _this = this;

			_this.matchBookCode = _this.$f7route.context.code;
			_this.startPageNo = _this.$f7route.context.startPageNo;
			_this.startExamNo =_this.$f7route.context.startExamNo;
			_this.endPageNo = _this.$f7route.context.endPageNo;
			_this.endExamNo = _this.$f7route.context.endExamNo;
			_this.studyKey = _this.$f7route.context.studyKey;
			_this.studyResultKey = _this.$f7route.context.studyResultKey;
			_this.studyType = _this.$f7route.context.studyType;

			setTimeout(function() {  
				
				if(_this.studyType == "mb-sdy") {

					if (_this.matchBookCode != undefined && _this.studyKey == undefined) {
						_this.loadMatchBookStudyInfo(_this.matchBookCode, _this.startPageNo, _this.startExamNo, _this.endPageNo, _this.endExamNo);	
					} else if (_this.matchBookCode != undefined && _this.studyKey != undefined) {
						_this.loadMatchBookResult(_this.studyKey);
					}
					
				}else if(_this.studyType == "mb-put") {

						if(_this.studyResultKey != undefined) {
							_this.loadMatchBookResult(_this.studyKey);
						}else if(_this.studyKey != undefined) {
							_this.loadMatchBookStudyInfo(_this.matchBookCode, _this.startPageNo, _this.startExamNo, _this.endPageNo, _this.endExamNo);	
						}
				}
				
			}, 300);
		},
		methods: {
			loadMatchBookStudyInfo(matchBookCode, startPageNo, startExamNo, endPageNo, endExamNo) {
				var _this = this;

				_this.matchBookCode = matchBookCode;

				var matchBookKey = MODULE.Util.codeToKey(CONST.matchBookCodePrefix, _this.matchBookCode);

				let param = {
					pMatchBookKey : matchBookKey,
					pStartPageNo : startPageNo, 
					pStartExamNo : startExamNo, 
					pEndPageNo : endPageNo, 
					pEndExamNo : endExamNo
				};


				API.ajaxRequest({
					url: API.getMatchBookApplyInfoUrl(),
					data: param
				}).then(function (data) {

					var commonObj = store.getters.commonObj;
					commonObj.mode = "ANSWER";
					commonObj.matchBookInfo = data.matchBookInfo;
					commonObj.answers = data.answers;
					_this.mode = commonObj.mode;
					_this.matchBookInfo = commonObj.matchBookInfo;
					_this.startPageNo = data.startPageNo;
					_this.startExamNo = data.startExamNo;
					_this.endPageNo = data.endPageNo;
					_this.endExamNo = data.endExamNo;
					_this.answers = commonObj.answers;

				}).catch(function (code) {
					if (code == CONST.resultCode.EMPTY) {
						PAGES.back();
						MODULE.DialogBox.message("에러", "존재하지 않는 코드입니다. 코드를 확인하세요.");
						return;
					}
					
					MODULE.UITool.catchBlock(code, PAGES, AUTH);
				});
			},	
			loadMatchBookResult(studyKey) {
				var _this = this;

				_this.studyKey = studyKey;

				let param = {
					pStudyKey : _this.studyKey
				};

				API.ajaxRequest({
					url: API.getMatchBookApplyResultUrl(),
					data: param
				}).then(function (data) {

					var commonObj = store.getters.commonObj;

					commonObj.mode = "SCORE";
					commonObj.matchBookInfo = data.matchBookInfo;
					commonObj.answers = data.answers;

					_this.mode = commonObj.mode;
					_this.matchBookInfo = commonObj.matchBookInfo;
					_this.startPageNo = data.startPageNo;
					_this.startExamNo = data.startExamNo;
					_this.endPageNo = data.endPageNo;
					_this.endExamNo = data.endExamNo;
					_this.answers = commonObj.answers;
					_this.matchBookCode = commonObj.matchBookInfo.MATCHBOOK_CODE;

					_this.forceRenderId++;
					
				}).catch(function (code) {
					MODULE.UITool.catchBlock(code, PAGES, AUTH);
				});
			},
			saveMatchBookResult(url, param){
				var _this = this;

				var result = MODULE.Util.checkValidateAnswers(param.pAnswers);
				
				var message = "";
				if (result.code != "OK") {					
					if (result.code == "EMPTY-ANSWER") {
						message = "비어있는 정답이 있습니다.<br/>조건에 맞지 않는 문항은 오답처리 됩니다.<br/>그래도 제출 할까요 ?";
					} else if (result.code == "OVERFLOW-LENGTH") {
						message = "정답이 너무 길어 잘리는 문항이 있습니다.<br/>잘린 문항은 오답처리 됩니다.<br/>그래도 제출 할까요 ?";
					}
				} else {
					message = "정답을 전송하고나면 변경할 수 없습니다.<br/>제출할까요 ?";
				}

				MODULE.DialogBox.okcancel(
					"정답 제출 확인", message,
					function() {	// on OK.					
				
						API.jsonRequest({
							url: url,
							data: param
						}).then(function (data) {

							if(data.point != undefined){
								MODULE.DialogBox.message("알림", "획득 포인트 :" + data.point);
							}

							var commonObj = store.getters.commonObj;
							commonObj.mode = "SCORE";
							commonObj.answers = data.answers;

							_this.mode = commonObj.mode;
							_this.answers = commonObj.answers;

							_this.forceRenderId++;
						}).catch(function (code) {
							MODULE.UITool.catchBlock(code, PAGES, AUTH);
						});
					}
				);

			},
			submitButtonClick() {
				var _this = this;
				var answers = store.getters.commonObj.answers;
				var url = "";
				var param = undefined;

				if(_this.studyType == "mb-sdy") {
					var matchBookKey = MODULE.Util.codeToKey(CONST.matchBookCodePrefix, _this.matchBookCode);
				
					param = {
						pStudyType : _this.studyType,
						pMatchBookKey : matchBookKey,
						pStartPageNo : _this.startPageNo, 
						pStartExamNo : _this.startExamNo, 
						pEndPageNo : _this.endPageNo, 
						pEndExamNo : _this.endExamNo,
						pAnswers: answers
					};		
					
					url = API.saveMatchBookSelfStudyUrl();

				}else if(_this.studyType == "mb-put") {
					
					param = {
						pStudyType : _this.studyType,
						pStudyKey : _this.studyKey,
						pStartPageNo : _this.startPageNo, 
						pStartExamNo : _this.startExamNo, 
						pEndPageNo : _this.endPageNo, 
						pEndExamNo : _this.endExamNo,
						pAnswers: answers
					};	
					
					url = API.saveMatchBookHomeWorkUrl();

				}

				_this.saveMatchBookResult(url,param);

			}
		}
	}

</script>